import { MouseEventHandler } from 'react'
import { NavigateFunction } from 'react-router-dom'

export const handleNavigate =
  (navigate: ((path: string) => void) | NavigateFunction, to: string, callback?: VoidFunction): MouseEventHandler =>
  (event) => {
    event.preventDefault()

    navigate(to)

    callback?.()

    return false
  }
